// 记录余料表格的列
export const recycleBinColumns = [
  {
    dataIndex: 'select',
    key: 'select',
    width: 60,
    fixed: 'left',
    scopedSlots: { customRender: 'select' },
    slots: { title: 'selectTitle' },
  },
  {
    dataIndex: 'name',
    key: 'name',
    title: '余料名称',
    width: 100,
    fixed: 'left',
    ellipsis: true,
    translateKey: 'surplusPage.surplusName',
  },
  {
    dataIndex: 'plankNum',
    key: 'plankNum',
    title: '余料条码',
    width: 140,
    fixed: 'left',
    ellipsis: true,
    translateKey: 'common.surplusNum',
  },
  {
    dataIndex: 'from_address',
    key: 'from_address',
    title: '来源订单地址',
    width: 150,
    ellipsis: true,
    translateKey: 'surplusPage.orderAddress',
  },
  {
    dataIndex: 'from_order_num',
    key: 'from_order_num',
    title: '来源订单号',
    width: 100,
    ellipsis: true,
    translateKey: 'surplusPage.orderId',
  },
  {
    dataIndex: 'surplusType',
    key: 'surplusType',
    title: '板材形状',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'surplusType' },
    translateKey: 'common.plankShape',
  },
  {
    dataIndex: 'type',
    key: 'type',
    title: '板材材质',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'type' },
    translateKey: 'common.plankMatCode',
  },
  {
    dataIndex: 'color',
    key: 'color',
    title: '板材颜色',
    width: 100,
    ellipsis: true,
    translateKey: 'common.plankColor',
  },
  {
    dataIndex: 'texDir',
    key: 'texDir',
    title: '纹理',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'texDir' },
    translateKey: 'common.texture',
  },
  {
    dataIndex: 'thick',
    key: 'thick',
    title: '厚度(mm)',
    width: 80,
    ellipsis: true,
    translateKey: 'common.thick',
  },
  {
    dataIndex: 'long',
    key: 'long',
    title: '长度(mm)',
    width: 80,
    ellipsis: true,
    translateKey: 'common.long',
  },
  {
    dataIndex: 'min_long',
    key: 'min_long',
    title: '短边长度(mm)',
    width: 120,
    ellipsis: true,
    translateKey: 'common.shortLong',
  },
  {
    dataIndex: 'width',
    key: 'width',
    title: '宽度(mm)',
    width: 80,
    ellipsis: true,
    translateKey: 'common.width',
  },
  {
    dataIndex: 'min_width',
    key: 'min_width',
    title: '短边宽度(mm)',
    width: 100,
    ellipsis: true,
    translateKey: 'common.shortWidth',
  },
  {
    dataIndex: 'update_time',
    key: 'update_time',
    title: '删除时间',
    width: 160,
    ellipsis: true,
    translateKey: 'surplusPage.deleteTime',
  },
  {
    dataIndex: 'delete_reason',
    key: 'delete_reason',
    title: '删除原因',
    width: 150,
    ellipsis: true,
    scopedSlots: { customRender: 'delete_reason' },
    translateKey: 'surplusPage.deleteReason',
  },
  {
    dataIndex: 'area',
    key: 'area',
    title: '面积(m²)',
    width: 100,
    ellipsis: true,
    translateKey: 'materialPage.surplusHead.area',
  },
  {
    dataIndex: 'surplus_trim_edge',
    key: 'surplus_trim_edge',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'surplus_trim_edge' },
    slots: { title: 'surplusTrimEdgeTitle' },
  },
  {
    dataIndex: 'is_high_gloss_plank',
    key: 'is_high_gloss_plank',
    title: '高光板',
    width: 110,
    scopedSlots: { customRender: 'is_high_gloss_plank' },
    ellipsis: true,
    translateKey: 'common.heighGlossPlank',
  },
  {
    dataIndex: 'highlight_surface',
    key: 'highlight_surface',
    title: '高光面',
    width: 110,
    scopedSlots: { customRender: 'highlight_surface' },
    ellipsis: true,
    translateKey: 'common.heighGlossSide',
  },
  {
    dataIndex: 'remark',
    key: 'remark',
    title: '备注',
    width: 100,
    ellipsis: true,
    translateKey: 'materialPage.surplusHead.remark',
  },
  {
    dataIndex: 'operation',
    key: 'operation',
    title: '操作',
    width: 140,
    fixed: 'right',
    scopedSlots: { customRender: 'operation' },
    translateKey: 'common.operation',
  },
]
